export function readFileAsDataURL(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => {
            resolve({ data: reader.result, name: file.name, mimeType: file.type, size: file.size })
        }
        reader.onerror = error => reject(error)
        reader.readAsDataURL(file)
    })
}

export async function readFilesAsDataURLs(files) {
    const results = []

    for (let index = 0; index < files.length; index++) {
        results.push(await readFileAsDataURL(files[index]))
    }

    return results
}

export async function readFileBytes(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => {
            resolve(reader.result)
        }
        reader.onerror = error => reject(error)
        reader.readAsArrayBuffer(file)
    })
}

export async function readFile(file) {
    const result = await readFileAsDataURL(file)
    return { base64: /base64,(.+)/.exec(result.data)[1], name: file.name, mimeType: file.type, size: file.size }
}

export async function readFiles(files) {
    const results = []

    for (let index = 0; index < files.length; index++) {
        results.push(await readFile(files[index]))
    }

    return results
}
